import React from 'react';
import PropTypes from 'prop-types';
import { FormGroup, Col, Label, FormFeedback } from 'reactstrap';
import classnames from 'classnames';

const FormGroupCheckbox = ({
  input,
  id,
  placeholder,
  label,
  rightLabel,
  meta: { touched, error },
}) => {
  let validationState = null;
  let errorText = null;

  if (touched) {
    if (error) {
      validationState = 'danger';
      errorText = error;
    } else {
      validationState = 'success';
    }
  }

  return (
    <FormGroup
      row
      color={validationState}
      className={classnames('form-group-2col', input.value && 'selected')}
    >
      <Label for={id} sm={3} xs={12}>
        {label}
      </Label>
      <Col sm={8} md={6} xs={12}>
        <Label className="custom-control custom-checkbox">
          <input
            {...input}
            id={id}
            type="checkbox"
            placeholder={placeholder}
            className="custom-control-input"
            checked={input.value}
          />
          <span className="custom-control-indicator" />
          {rightLabel}
        </Label>
        <FormFeedback>{errorText}</FormFeedback>
      </Col>
    </FormGroup>
  );
};

FormGroupCheckbox.propTypes = {
  input: PropTypes.shape({}),
  id: PropTypes.string,
  placeholder: PropTypes.string,
  label: PropTypes.string,
  rightLabel: PropTypes.string,
  meta: PropTypes.shape({}),
};

export default FormGroupCheckbox;
